import { fetchApi } from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";
import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToClaimCancelReason = mapDictionaryState;

const claimCancelReasonApi = createDictionaryApiFactory("claimCancelReason");

export const getClaimCancelReason = claimCancelReasonApi.search;
export const getClaimCancelReasonDetail = claimCancelReasonApi.getDetail;
export const createClaimCancelReason = claimCancelReasonApi.save;
export const exportCsvClaimCancelReason = claimCancelReasonApi.exportCsv;

export const getClaimCancelReasonSelectItems = async (): Promise<SelectItemDto[]> => {
    return await fetchApi.get('/claimCancelReason/select') as SelectItemDto[];
};
